import React from 'react';

export default class Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">WHAT IS MEANT BY CHALLENGE AND SUPPORT?</span>
                                            </div>
                                            <div className="border_subtitle">Challenge</div>
                                            <p>Many people think challenge is something negative. Talking about
                                                ‘challenging others’ in most discussions about personal or
                                                professional development is often assumed to mean disagreeing
                                                with others in some way. The word ‘challenge’, in fact, has
                                                three different definitions.</p>
                                            <div className="lightgreencontentbg keyquestionpad">
                                                <div className="paraspace"><p><span
                                                    className="boldtext numberpadding">1  :</span> a demanding
                                                    or stimulating situation.</p>
                                                    <p><span className="boldtext numberpadding">2 :</span> a
                                                        call to engage in contest, fight, or argument.</p></div>
                                                <div className="uiheading"><p><span
                                                    className="boldtext numberpadding">3 :</span> a questioning
                                                    of a statement or fact.</p></div>
                                            </div>
                                            <p>This isn’t all negative – indeed, the first definition can be
                                                extremely positive. Challenging will of course sometimes mean
                                                ruffling some feathers, but that doesn’t mean it can’t have a
                                                decent outcome. What most senior leaders would regard as a
                                                successful challenge is where an employee needs to take a
                                                different approach in their actions, and you successfully
                                                negotiate them onto this path. There are several ways to do this
                                                depending on the situation; for more information look at the
                                                ‘How to influence others’ iLEAD™ tool.</p>
                                            <div className="border_subtitle">Support</div>
                                            <p>When we talk about support in the workplace we mean providing
                                                some form of assistance to others. Again, a dictionary
                                                definition may be useful:</p>
                                            <div className="lightgreencontentbg keyquestionpad">
                                                <div className="paraspace"><p><span
                                                    className="boldtext numberpadding">1 :</span> to give
                                                    practical or emotional help to someone.</p>
                                                    <p><span className="boldtext numberpadding">2 :</span> to
                                                        give approval to (a cause, political idea).</p></div>
                                                <div className="uiheading"><p><span
                                                    className="boldtext numberpadding">3 :</span> to take an
                                                    active interest in and be loyal…</p></div>
                                            </div>
                                            <p>Again, different circumstances require different means of
                                                support. Understanding what kind of support is required in a
                                                situation is vital to providing the necessary help and
                                                encouragement.</p>
                                            <p>So, when challenging people, it may be necessary to offer support
                                                at the same time to provide the necessary balance of
                                                reinforcement. For example, if you found something at work very
                                                challenging you might find it useful to have someone to talk to
                                                about it. Supporting and challenging others requires flexibility
                                                according to their differing requirements – and getting this
                                                balance right is where you can make the biggest difference to
                                                performance, commitment and motivation.</p>

                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">MOTIVATIONAL WELLBEING</span>
                                            </div>
                                            <p>Prof. Cary Cooper and his colleague Prof. Ivan Robertson have
                                                conducted decades of research into workplace psychology,
                                                including motivational factors. Clearly, you want motivated
                                                people at work because without motivation, people may not
                                                perform or may become disengaged and eventually look for work
                                                elsewhere. Below is a Robertson-Cooper<a
                                                    className="superscripttext"
                                                    href="further_info.php?course=300"><sup>2</sup></a> model
                                                showing the relationship between pressure (challenge) and
                                                performance.</p>
                                            <div className="innovativeimg">
                                                <img
                                                    src={require('@images/moto_well_img.png')}
                                                    alt="" className=""/>
                                            </div>
                                            <div className="buttonposition">
                                                <div className="left-btn">
                                                    <div
                                                        onClick={this.props.handleChangePage('Page1')}
                                                        className="button-next-previous-done">&lt;&lt; Previous
                                                    </div>
                                                </div>
                                                <div className="right-btn">
                                                    <div
                                                        onClick={this.props.handleChangePage('Page3')}
                                                        className="button-next-previous-done">Next &gt;&gt;</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}